import type {
  AstroConfigMissingFontProvidersImportIssue,
  AstroConfigMissingFontsArrayIssue,
  AstroConfigMissingManifestImportIssue,
  AstroConfigMissingManifestReferenceIssue,
  FontSystemIssue,
  MissingAstroConfigIssue,
} from "./types"
import { ASTRO_CONFIG_PATH } from "./constants"

const FONT_PROVIDERS_IMPORT_RE = /import\s*\{[\s\S]*\bfontProviders\b[\s\S]*\}\s*from\s*["']astro\/config["']/
const FONT_MANIFEST_IMPORT_RE = /import\s+([A-Za-z_$][\w$]*)\s+from\s+["'][^"']*font-manifest\.json["'][^;\n]*/

const missingAstroConfig = (): MissingAstroConfigIssue => ({
  _tag: "MissingAstroConfig",
  path: ASTRO_CONFIG_PATH,
})

const astroConfigMissingFontProvidersImport = (): AstroConfigMissingFontProvidersImportIssue => ({
  _tag: "AstroConfigMissingFontProvidersImport",
  path: ASTRO_CONFIG_PATH,
})

const astroConfigMissingManifestImport = (): AstroConfigMissingManifestImportIssue => ({
  _tag: "AstroConfigMissingManifestImport",
  path: ASTRO_CONFIG_PATH,
})

const astroConfigMissingFontsArray = (): AstroConfigMissingFontsArrayIssue => ({
  _tag: "AstroConfigMissingFontsArray",
  path: ASTRO_CONFIG_PATH,
})

const astroConfigMissingManifestReference = (
  reference: string,
): AstroConfigMissingManifestReferenceIssue => ({
  _tag: "AstroConfigMissingManifestReference",
  path: ASTRO_CONFIG_PATH,
  reference,
})

export const validateAstroFontConfig = (
  input: string | null | undefined,
): readonly FontSystemIssue[] => {
  if (input == null) {
    return [missingAstroConfig()]
  }

  const issues: FontSystemIssue[] = []

  if (!FONT_PROVIDERS_IMPORT_RE.test(input)) {
    issues.push(astroConfigMissingFontProvidersImport())
  }

  const manifestImport = input.match(FONT_MANIFEST_IMPORT_RE)
  if (!manifestImport) {
    issues.push(astroConfigMissingManifestImport())
  }

  if (!/\bfonts\s*:/.test(input)) {
    issues.push(astroConfigMissingFontsArray())
  }

  if (!/fontProviders\.google\(\)/.test(input)) {
    issues.push(astroConfigMissingManifestReference("fontProviders.google()"))
  }

  if (!manifestImport) {
    return issues
  }

  const identifier = manifestImport[1]
  const expectedReferences = [
    `${identifier}.body.name`,
    `${identifier}.body.weights`,
    `${identifier}.body.cssVariable`,
    `${identifier}.heading.name`,
    `${identifier}.heading.weights`,
    `${identifier}.heading.cssVariable`,
  ]

  for (const reference of expectedReferences) {
    if (!input.includes(reference)) {
      issues.push(astroConfigMissingManifestReference(reference))
    }
  }

  return issues
}
